import { twMerge } from "tailwind-merge"

interface Props {
  checked?: boolean
  className?: string
  emoji?: string
  image?: string
  label?: string
  name?: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  text?: string
  value: string
  variant?: "default" | "unit"
  layout?: "horizontal" | "vertical"
}

export default function RadioInputButton({
  checked,
  className,
  emoji,
  image,
  label,
  name,
  onChange,
  text,
  value,
  variant = "default",
  layout = "horizontal",
}: Props) {
  const isVertical = layout === "vertical"

  return (
    <label
      className={twMerge(
        isVertical
          ? "flex flex-col items-center text-center"
          : "flex items-center gap-3",
        variant === "unit" ? "custom-button-unit-input" : "custom-button-input",
        checked && "custom-button-input-selected",
        className,
      )}
    >
      <input
        checked={checked}
        className="hidden"
        name={name}
        onChange={onChange}
        type="radio"
        value={value}
      />

      {image && <img className="mr-1 w-16 rounded-xl" src={image} />}

      {emoji && (
        <span className={twMerge("mr-1", label ? "text-lg" : "text-2xl")}>
          {emoji}
        </span>
      )}

      {isVertical ? (
        <>
          <span className="text-custom-charcoal font-semibold">{label}</span>
          {text && <span className="text-sm text-gray-500">{text}</span>}
        </>
      ) : (
        <div className="flex flex-col">
          <span className="text-custom-charcoal font-semibold">{label}</span>
          {text && <span className="text-sm text-gray-500">{text}</span>}
        </div>
      )}
    </label>
  )
}
